/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ContentZoneContext } from "cms/components/context";
import { isEmpty } from "lodash";
import { Fragment, useContext } from "react";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { CTAHorizontal } from "./horizontal";
import { CTAVertical } from "./vertical";

const CallToActionComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const {
        imageCard,
        image = "",
        title = "",
        description = "",
        links = [],
        settings
    } = component || {};
    const { style, format } = settings || {};
    const hasContent = !isEmpty(title);
    const isVertical = imageCard === "vertical";
    const isHorizontal = imageCard === "horizontal";
    const direction = isVertical ? "vertical" : "horizontal";
    
    return (
        <div className={`cta-container ${direction}`}>
            
            {hasContent &&
                <Fragment>
                    {isVertical &&
                        <CTAVertical
                            image={image}
                            title={title}
                            description={description}
                            links={links}
                            style={style}
                            format={format}
                        />
                    }
                    
                    {isHorizontal &&
                        <CTAHorizontal
                            image={image}
                            title={title}
                            description={description}
                            links={links}
                            style={style}
                            format={format}
                        />
                    }
                
                </Fragment>
            }
            
            {!hasContent &&
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            }
        </div>
    );
};
CallToActionComponentDisplay.displayName = "CallToActionComponentDisplay";
export { CallToActionComponentDisplay };
